module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-intl/gatsby-browser.js'),
      options: {"plugins":[],"path":"/home/runner/work/fatih-sahanoglu.github.io/fatih-sahanoglu.github.io/src/intl","languages":["en-US","de-DE"],"defaultLanguage":"en-US","redirect":true},
    }]
